export const ToastMessageTypes = {
  error: 'error',
  info: 'info',
  success: 'success',
  warning: 'warning',
} as const;
